// ─── CONTACT INFO (from travizonmigration.com) ───
export const WHATSAPP_NUMBER = "923084715628";
export const WHATSAPP_NUMBER_VISIT = "923210784000";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const WHATSAPP_URL_VISIT = `https://wa.me/${WHATSAPP_NUMBER_VISIT}`;
export const EMAIL = "info@travizonmigration.com";
export const PHONE = "0308 4715628";
export const PHONE_VISIT = "0321 0784000";
export const ADDRESS = "UGF-23,24 Century Tower, Gulberg-3, Lahore";
export const HOURS = "Mon–Sat: 9:00 AM – 7:00 PM PKT";

// ─── NAV LINKS ───
export const navLinks = [
  { label: "Services", page: "services" },
  { label: "Destinations", page: "destinations" },
  { label: "Migration", page: "migration" },
  { label: "Scholarships", page: "scholarships" },
  { label: "Insurance", page: "insurance" },
  { label: "Success Stories", page: "stories" },
  { label: "FAQ", page: "faq" },
];

// ─── STATS ───
export const stats = [
  { n: 500, s: "+", label: "Visas Approved" },
  { n: 35, s: "+", label: "Study Destinations" },
  { n: 5, s: "", label: "Skilled Migration Pathways" },
  { n: 98, s: "%", label: "Approval Rate" },
  { n: 200, s: "+", label: "University Partners" },
  { n: 7, s: "+", label: "Years Experience" },
];

// ─── TRUST BAR ───
export const trustItems = [
  { icon: "🛡️", label: "100% Legal Process" },
  { icon: "✅", label: "Transparent Fees" },
  { icon: "👨‍👩‍👧", label: "500+ Families Helped" },
  { icon: "⏱️", label: "Response Within 2 Hours" },
  { icon: "📞", label: "Free First Consultation" },
];

// ─── STUDY ABROAD COUNTRIES (35) ───
export const studyCountries = [
  { flag: "🇺🇸", name: "USA", tag: "F-1 · J-1" },
  { flag: "🇦🇺", name: "Australia", tag: "Student Visa" },
  { flag: "🇨🇦", name: "Canada", tag: "SDS · Non-SDS" },
  { flag: "🇬🇧", name: "UK", tag: "Student Visa" },
  { flag: "🇳🇿", name: "New Zealand", tag: "Student Visa" },
  { flag: "🇸🇬", name: "Singapore", tag: "Student Pass" },
  { flag: "🇦🇪", name: "UAE", tag: "Student Visa" },
  { flag: "🇮🇪", name: "Ireland", tag: "Study Visa" },
  { flag: "🇫🇷", name: "France", tag: "VLS-TS" },
  { flag: "🇩🇪", name: "Germany", tag: "National Visa" },
  { flag: "🇸🇪", name: "Sweden", tag: "Residence Permit" },
  { flag: "🇳🇱", name: "Netherlands", tag: "MVV · TEV" },
  { flag: "🇦🇹", name: "Austria", tag: "National Visa D" },
  { flag: "🇩🇰", name: "Denmark", tag: "Residence Permit" },
  { flag: "🇫🇮", name: "Finland", tag: "Residence Permit" },
  { flag: "🇮🇹", name: "Italy", tag: "Student Visa D" },
  { flag: "🇭🇺", name: "Hungary", tag: "Student Visa" },
  { flag: "🇨🇭", name: "Switzerland", tag: "National Visa" },
  { flag: "🇪🇸", name: "Spain", tag: "Student Visa" },
  { flag: "🇱🇹", name: "Lithuania", tag: "National Visa D" },
  { flag: "🇨🇾", name: "Cyprus", tag: "Student Visa" },
  { flag: "🇵🇱", name: "Poland", tag: "National Visa D" },
  { flag: "🇲🇾", name: "Malaysia", tag: "Student Pass" },
  { flag: "🇨🇳", name: "China", tag: "X1 · X2 Visa" },
  { flag: "🇯🇵", name: "Japan", tag: "Student Visa" },
  { flag: "🇧🇪", name: "Belgium", tag: "Student Visa" },
  { flag: "🇷🇺", name: "Russia", tag: "Student Visa" },
  { flag: "🇰🇷", name: "South Korea", tag: "D-2 Visa" },
  { flag: "🇬🇪", name: "Georgia", tag: "Student Visa" },
  { flag: "🇲🇨", name: "Monaco", tag: "Student Visa" },
  { flag: "🇭🇷", name: "Croatia", tag: "National Visa D" },
  { flag: "🇱🇻", name: "Latvia", tag: "Long-stay Visa" },
  { flag: "🇹🇭", name: "Thailand", tag: "ED Visa" },
  { flag: "🇱🇺", name: "Luxembourg", tag: "Student Visa" },
  { flag: "🇬🇷", name: "Greece", tag: "National Visa D" },
  { flag: "🇹🇷", name: "Turkey", tag: "Student Visa" },
];

// ─── SKILLED MIGRATION ───
export const skilledMigration = [
  { flag: "🇩🇪", country: "Germany", visa: "Opportunity Card (Chancenkarte)", desc: "Germany's points-based job seeker visa allows skilled professionals to move to Germany and search for work without a prior job offer. Points based on qualification, language, age, and experience.", cta: "Enquire Now →" },
  { flag: "🇦🇹", country: "Austria", visa: "Job Seeker Visa", desc: "Austria's Red-White-Red Card job seeker permit allows highly qualified individuals to relocate to Austria and actively search for employment for up to 6 months.", cta: "Enquire Now →" },
  { flag: "🇸🇪", country: "Sweden", visa: "Job Seeker Visa", desc: "Sweden's job seeker residence permit allows qualified graduates and professionals to enter Sweden and search for a skilled job or explore opportunities to start a business.", cta: "Enquire Now →" },
  { flag: "🇦🇺", country: "Australia", visa: "Skilled Migration — GSM (491 / 190)", desc: "Australia's points-tested skilled migration stream. Subclass 190 (permanent state nomination) and 491 (regional skilled — pathway to PR). We calculate your points and manage the full EOI process.", cta: "Calculate My Points →" },
  { flag: "🇺🇸", country: "USA", visa: "EB-2 NIW (National Interest Waiver)", desc: "The EB-2 NIW allows professionals with advanced degrees or exceptional ability to self-petition for a US green card without employer sponsorship — ideal for researchers, doctors, engineers, and academics.", cta: "Check Eligibility →" },
];

// ─── DIGITAL NOMAD ───
export const digitalNomad = [
  { flag: "🇪🇺", name: "Europe", sub: "Multiple country options available" },
  { flag: "🇦🇪", name: "Dubai / UAE", sub: "Virtual Working Programme" },
  { flag: "🇹🇭", name: "Thailand", sub: "LTR Visa — Remote Workers" },
  { flag: "🇰🇷", name: "South Korea", sub: "Digital Nomad Visa (Workcation)" },
  { flag: "🇯🇵", name: "Japan", sub: "Digital Nomad Visa" },
  { flag: "🇨🇷", name: "Costa Rica", sub: "Rentista / Digital Nomad Visa" },
  { flag: "🇵🇦", name: "Panama", sub: "Short Stay Digital Nomad Visa" },
];

// ─── VISIT VISA ───
export const visitVisas = [
  { flag: "🇺🇸", name: "USA", type: "B-1 / B-2 Tourist Visa" },
  { flag: "🇨🇦", name: "Canada", type: "Temporary Resident Visa (TRV)" },
  { flag: "🇬🇧", name: "United Kingdom", type: "Standard Visitor Visa" },
  { flag: "🇪🇺", name: "Europe", type: "Multiple Schengen Countries" },
  { flag: "🇯🇵", name: "Japan", type: "Tourist / Visitor Visa" },
  { flag: "🛂", name: "Schengen", type: "26 European Countries" },
  { flag: "🇹🇷", name: "Turkey", type: "Tourist / e-Visa" },
  { flag: "🇿🇦", name: "South Africa", type: "Visitor Visa" },
  { flag: "🇲🇦", name: "Morocco", type: "Tourist Visa" },
];

// ─── ACCOMMODATION ───
export const accommodation = [
  { flag: "🇨🇦", name: "Canada", sub: "Student & family housing" },
  { flag: "🇺🇸", name: "USA", sub: "On & off campus" },
  { flag: "🇬🇧", name: "United Kingdom", sub: "Halls & private rentals" },
  { flag: "🇩🇪", name: "Germany", sub: "Studentenwohnheim & WG" },
  { flag: "🇫🇮", name: "Finland", sub: "Student housing" },
  { flag: "🇦🇹", name: "Austria", sub: "Studentenheim & private" },
  { flag: "🇮🇹", name: "Italy", sub: "Casa dello studente" },
  { flag: "🇪🇸", name: "Spain", sub: "Residencia universitaria" },
  { flag: "🇳🇱", name: "Netherlands", sub: "Rooms & apartments" },
  { flag: "🇦🇪", name: "UAE", sub: "Dubai & Abu Dhabi" },
  { flag: "🇮🇪", name: "Ireland", sub: "Student & family" },
  { flag: "🇦🇺", name: "Australia", sub: "On campus & private" },
  { flag: "🇳🇿", name: "New Zealand", sub: "Student & rental housing" },
];

// ─── SCHOLARSHIPS ───
export const scholarships = [
  {
    flag: "🇬🇧", name: "Chevening Scholarship", country: "United Kingdom", type: "full",
    value: "Covers full tuition, living allowance, flights, and visa fees for a 1-year Master's degree at any UK university.",
    steps: ["Apply online via chevening.org (Sep–Nov)", "Two professional references required", "Interview shortlisting", "Visa and pre-departure support"],
    deadline: "November annually",
  },
  {
    flag: "🇪🇺", name: "Erasmus+ Scholarship", country: "Europe — 30+ Countries", type: "full",
    value: "Covers tuition, monthly living stipend, and travel allowance. Study, train, or volunteer across Europe.",
    steps: ["Apply through your home university", "Open to students and young professionals", "Mobility periods of 2–12 months", "Available for study, internship, and staff"],
    deadline: "Varies by institution",
  },
  {
    flag: "🇩🇪", name: "DAAD Scholarship", country: "Germany", type: "full",
    value: "Monthly stipend of €850–€1,200 + health insurance + tuition waiver for study or research in Germany.",
    steps: ["Apply via DAAD portal", "Academic excellence required", "Language proficiency (German or English)", "Research proposal for postgrad"],
    deadline: "October–November annually",
  },
  {
    flag: "🇸🇪", name: "Swedish Institute Scholarship (SISGP)", country: "Sweden", type: "full",
    value: "Full tuition + SEK 11,000/month living allowance + travel grant for a Master's degree in Sweden.",
    steps: ["Apply via SI application portal", "Must have 3 years work experience", "English B2 minimum required", "Commitment to return and develop home country"],
    deadline: "February annually",
  },
  {
    flag: "🇫🇷", name: "Eiffel Excellence Scholarship", country: "France", type: "full",
    value: "€1,181/month for Master's + €1,400/month for PhD + accommodation aid + cultural activities.",
    steps: ["Nominated by French institution", "Exceptional academic record required", "Fields: engineering, economics, law, political science", "Up to 3 years coverage"],
    deadline: "January annually",
  },
  {
    flag: "🇦🇹", name: "OeAD Government Scholarship", country: "Austria", type: "partial",
    value: "€1,050–€1,500/month + tuition waiver for research stay or full degree in Austria.",
    steps: ["Apply via OeAD scholarship portal", "Academic merit + research plan", "German or English proficiency", "Valid for 1 month to 9 months"],
    deadline: "March annually",
  },
  {
    flag: "🇮🇹", name: "Italian Government Scholarship (DSU)", country: "Italy", type: "full",
    value: "Full tuition waiver + €900/month living allowance + accommodation for Bachelor's, Master's, or PhD in Italy.",
    steps: ["Apply via universitaly.it portal", "ISEE financial assessment required", "Open to undergraduate and postgraduate", "Renewable annually based on merit"],
    deadline: "August annually",
  },
  {
    flag: "🇫🇮", name: "Finland Scholarship (University-Based)", country: "Finland", type: "partial",
    value: "Tuition fee waivers of 50–100% + monthly stipend at select Finnish universities.",
    steps: ["Apply directly to Finnish universities", "Merit-based selection", "English proficiency required", "Aalto, Helsinki, Tampere offer strong programs"],
    deadline: "January annually",
  },
];

// ─── INSURANCE ───
export const insurance = [
  {
    icon: "🏥", name: "Student Health Insurance", desc: "Mandatory for most student visas. Covers medical treatment, hospitalisation, emergencies, and prescriptions abroad.",
    features: ["Medical & hospital cover", "Emergency evacuation", "Prescription drugs", "Mental health coverage", "Dental & optical (optional)"],
  },
  {
    icon: "✈️", name: "Travel & Visit Insurance", desc: "Required for Schengen and many other visit visas. Covers medical emergencies, trip cancellation, lost luggage, and delays.",
    features: ["Medical emergency cover (€30,000 minimum for Schengen)", "Trip cancellation & delay", "Lost or stolen baggage", "Repatriation cover", "24/7 emergency assistance"],
  },
  {
    icon: "🌍", name: "International Health Insurance", desc: "For families and professionals relocating abroad long-term. Comprehensive health cover across multiple countries.",
    features: ["Inpatient & outpatient cover", "Maternity & newborn", "Pre-existing conditions", "Multi-country coverage", "Family plans available"],
  },
  {
    icon: "💼", name: "Work Abroad Insurance", desc: "For skilled migrants and workers abroad. Covers income protection, public liability, and employer liability requirements.",
    features: ["Income protection", "Public & employer liability", "Personal accident cover", "Legal expenses", "Employer requirement compliance"],
  },
];

// ─── PROCESS STEPS ───
export const processSteps = [
  { n: "1", title: "Free Consultation", desc: "In-person at Century Tower, Gulberg-3 or via WhatsApp / video call. We listen — no pressure, no sales pitch." },
  { n: "2", title: "Honest Profile Assessment", desc: "We review your eligibility, documents, financial history, and profile. We tell you your real chances before you commit." },
  { n: "3", title: "Application Preparation", desc: "Tailored cover letter, document compilation, financial presentation — every file reviewed by our team before submission." },
  { n: "4", title: "Submission & Tracking", desc: "We submit on your behalf, track the application, and keep you updated. No chasing, no silence." },
  { n: "5", title: "You travel. We celebrate.", desc: "Visa approved — and if you need accommodation or post-arrival support, we are still here.", highlight: true },
];

// ─── WHY US ───
export const whyUs = [
  { icon: "🛡️", title: "100% legal process", desc: "We never submit false documents or shortcuts. Every application is prepared for full embassy scrutiny." },
  { icon: "👁️", title: "Radical transparency", desc: "We tell you exactly what you're paying for, your real chances, and what could go wrong — before you commit." },
  { icon: "🎯", title: "Outcome-focused", desc: "Our success is measured by your visa approval — not the number of consultations booked." },
  { icon: "🤝", title: "Full journey support", desc: "Visa. Admission. Accommodation. We are not done until you are settled — not just stamped." },
];

// ─── TESTIMONIALS ───
export const testimonials = [
  { initial: "AK", name: "Ahmed K.", role: "UK Visit Visa · Lahore", text: "I had been rejected twice before. Travizon found the exact issues and fixed them. UK visa approved in 6 weeks.", color: "from-teal to-teal-light" },
  { initial: "SR", name: "Sadia R.", role: "Canada Student Visa · Lahore", text: "They helped my daughter get admission in Canada and handled the student visa entirely. Completely transparent throughout.", color: "from-navy-light to-blue-600" },
  { initial: "MU", name: "Muhammad U.", role: "Australia Migration · Lahore", text: "Professional, honest, and thorough. Travizon did not just get me a visa — they found me accommodation in Australia too.", color: "from-emerald-600 to-green-400" },
  { initial: "FA", name: "Fareeha A.", role: "Germany DAAD Scholarship · Lahore", text: "Got 100% DAAD scholarship guidance. Travizon prepared my SOP, helped with documents, and I got accepted to TU Munich.", color: "from-purple-500 to-violet-400" },
  { initial: "HS", name: "Hassan S.", role: "Schengen Visit Visa · Lahore", text: "Applied for Schengen independently twice and was refused. Travizon rebuilt my entire application and I was approved in 3 weeks.", color: "from-gold to-gold-light text-navy-deep" },
  { initial: "RK", name: "Rida K.", role: "Sweden Skilled Migration · Lahore", text: "The Sweden job seeker visa process seemed impossible. Travizon handled it step by step — I'm now settled in Stockholm.", color: "from-rose-600 to-red-400" },
];

// ─── FAQS ───
export const faqs = [
  { q: "How much does a consultation cost?", a: "The first consultation is completely free — no fees, no obligation. We assess your profile and give you an honest assessment. If you proceed, all fees are explained transparently before any commitment." },
  { q: "I was refused before. Can I still apply?", a: "Yes. A refusal is not permanent. Most refusals result from weak financial evidence, a poor cover letter, or insufficient ties to Pakistan. We identify exactly what went wrong and rebuild a much stronger application." },
  { q: "How long does a visa application take?", a: "Processing times vary. UK standard visit visa: 3–8 weeks. Canada student permit: 8–16 weeks. Schengen: 15–30 working days. Australian skilled migration: 6–12 months. We always advise applying early." },
  { q: "Do you cover the full study abroad process or just visas?", a: "We cover everything: university selection and shortlisting, application and admission, SOP writing, financial documentation, visa application, and accommodation. One team handles your complete journey." },
  { q: "What is a Digital Nomad Visa and am I eligible?", a: "A Digital Nomad Visa allows you to legally live in a country while working remotely for a foreign employer or as a freelancer. Requirements vary by country but typically include proof of remote employment and a minimum monthly income." },
  { q: "Can you guarantee visa approval?", a: "No — and avoid any agent who claims they can. The final decision is always with the embassy. What we guarantee is a thoroughly prepared, honest, professionally presented application that gives you the strongest possible chance." },
  { q: "Which countries do you support for study abroad?", a: "We support 35+ countries including UK, Canada, Australia, USA, Germany, France, Sweden, Finland, Austria, Italy, Netherlands, Lithuania, Cyprus, Poland, Malaysia, China, Japan, South Korea, Georgia, and more." },
  { q: "Do you support accommodation arrangements?", a: "Yes. We have verified accommodation partners in 13 countries including Canada, USA, UK, Germany, Australia, Finland, Austria, Italy, Spain, Netherlands, UAE, Ireland, and New Zealand." },
  { q: "What scholarships can you help with?", a: "We guide you through Chevening (UK), Erasmus+ (Europe), DAAD (Germany), Swedish Institute (Sweden), Eiffel Excellence (France), OeAD (Austria), Italian Government scholarship, and many university-specific awards." },
  { q: "Do I need to visit your office or can I consult online?", a: "Both options are available. You can visit us in person at UGF-23,24 Century Tower, Gulberg-3, Lahore, or consult via WhatsApp, Zoom, or video call — whatever is convenient for you." },
];

// ─── SUCCESS STORIES ───
export const successStories = [
  { initial: "AK", color: "from-teal to-teal-light", flag: "🇬🇧", name: "Ahmed K. — UK Visit Visa", role: "Lahore | 2024", text: "I had been rejected twice before finding Travizon. They reviewed both refusals, identified that my financial evidence was presented incorrectly, and rebuilt the entire application with a properly structured cover letter. My UK visa was approved in 6 weeks. The difference was the level of detail — they treated my case like it mattered.", tags: ["UK Visit Visa", "Refusal Recovery", "Financial Documentation"] },
  { initial: "SR", color: "from-navy-light to-blue-600", flag: "🇨🇦", name: "Sadia R. — Canada Student Visa", role: "Parent, Lahore | 2023", text: "Travizon handled my daughter's complete Canada journey — from university shortlisting to admission to student visa. Everything was explained clearly, every document was checked multiple times. No surprises, no hidden fees. She's now in her second year at University of Toronto.", tags: ["Canada Student Permit", "University Admission", "Full Journey"] },
  { initial: "MU", color: "from-emerald-600 to-green-400", flag: "🇦🇺", name: "Muhammad U. — Australia Migration", role: "Lahore | 2024", text: "Professional and thorough. Travizon not only guided my Australian skilled migration application, they also arranged my accommodation before I landed. I wasn't chasing anyone — they kept me updated every step. I'm now settled in Melbourne.", tags: ["Australian Skilled Migration", "Accommodation Arranged", "End-to-End"] },
  { initial: "FA", color: "from-purple-500 to-violet-400", flag: "🇩🇪", name: "Fareeha A. — DAAD Scholarship", role: "Lahore | 2023", text: "I applied for the DAAD scholarship twice on my own and was rejected both times. Travizon rebuilt my SOP completely, helped structure my research proposal, and explained exactly what the committee was looking for. Third attempt — I was selected. Now studying at TU Munich fully funded.", tags: ["DAAD Scholarship", "SOP Rewrite", "Germany"] },
];

// ─── UNIVERSITY PARTNERS (for marquee) ───
export const ukUniversities = [
  { flag: "🇬🇧", name: "University of Oxford", country: "Oxford, UK" },
  { flag: "🇬🇧", name: "University of Cambridge", country: "Cambridge, UK" },
  { flag: "🇬🇧", name: "Imperial College London", country: "London, UK" },
  { flag: "🇬🇧", name: "UCL", country: "London, UK" },
  { flag: "🇬🇧", name: "University of Manchester", country: "Manchester, UK" },
  { flag: "🇬🇧", name: "King's College London", country: "London, UK" },
  { flag: "🇬🇧", name: "University of Edinburgh", country: "Edinburgh, UK" },
  { flag: "🇬🇧", name: "University of Birmingham", country: "Birmingham, UK" },
  { flag: "🇬🇧", name: "University of Leeds", country: "Leeds, UK" },
  { flag: "🇬🇧", name: "University of Sheffield", country: "Sheffield, UK" },
];

export const intlUniversities = [
  { flag: "🇦🇺", name: "University of Melbourne", country: "Melbourne, Australia" },
  { flag: "🇦🇺", name: "University of Sydney", country: "Sydney, Australia" },
  { flag: "🇦🇺", name: "UNSW Sydney", country: "Sydney, Australia" },
  { flag: "🇦🇺", name: "Monash University", country: "Melbourne, Australia" },
  { flag: "🇺🇸", name: "Harvard University", country: "Boston, USA" },
  { flag: "🇺🇸", name: "MIT", country: "Cambridge, USA" },
  { flag: "🇺🇸", name: "New York University", country: "New York, USA" },
  { flag: "🇺🇸", name: "UCLA", country: "Los Angeles, USA" },
  { flag: "🇨🇦", name: "University of Toronto", country: "Toronto, Canada" },
  { flag: "🇨🇦", name: "McGill University", country: "Montreal, Canada" },
  { flag: "🇨🇦", name: "UBC", country: "Vancouver, Canada" },
  { flag: "🇨🇦", name: "University of Waterloo", country: "Waterloo, Canada" },
];

export const europeUniversities = [
  { flag: "🇦🇹", name: "University of Vienna", country: "Vienna, Austria" },
  { flag: "🇦🇹", name: "TU Wien", country: "Vienna, Austria" },
  { flag: "🇫🇷", name: "Sorbonne University", country: "Paris, France" },
  { flag: "🇫🇷", name: "Sciences Po Paris", country: "Paris, France" },
  { flag: "🇫🇷", name: "HEC Paris", country: "Paris, France" },
  { flag: "🇮🇹", name: "Politecnico di Milano", country: "Milan, Italy" },
  { flag: "🇮🇹", name: "University of Bologna", country: "Bologna, Italy" },
  { flag: "🇱🇹", name: "Vilnius University", country: "Vilnius, Lithuania" },
  { flag: "🇸🇪", name: "KTH Royal Institute", country: "Stockholm, Sweden" },
  { flag: "🇸🇪", name: "Lund University", country: "Lund, Sweden" },
  { flag: "🇫🇮", name: "University of Helsinki", country: "Helsinki, Finland" },
  { flag: "🇫🇮", name: "Aalto University", country: "Espoo, Finland" },
  { flag: "🇩🇪", name: "TU Munich", country: "Munich, Germany" },
  { flag: "🇩🇪", name: "Heidelberg University", country: "Heidelberg, Germany" },
  { flag: "🇳🇱", name: "Delft University", country: "Delft, Netherlands" },
];

// ─── VALUE ADDED SERVICES ───
export const valueAddedServices = [
  {
    icon: "✈️",
    title: "Airport Pickup",
    desc: "Stress-free arrival with a trusted Travizon driver waiting for you at arrivals. Available in UK, Canada, Australia, Germany & more.",
    features: ["Pre-booked & confirmed 48hrs prior", "Flight tracking included", "WhatsApp contact shared before travel", "Available 24/7 including holidays"],
    color: "from-blue-500 to-blue-400",
  },
  {
    icon: "🏥",
    title: "Insurance Activation",
    desc: "We don't just arrange your insurance — we activate it, confirm your coverage documents, and ensure it meets your visa requirements.",
    features: ["Same-day activation available", "Embassy-compliant documents issued", "Schengen, UK, Australia, Canada covered", "Policy review & gap analysis"],
    color: "from-emerald-500 to-green-400",
  },
  {
    icon: "📱",
    title: "SIM Card Activation",
    desc: "Arrive with a working local number, data plan, and WhatsApp active. No roaming charges, no confusion at the airport.",
    features: ["Pre-activated before arrival", "Best local carrier selected per country", "Data + calls bundle included", "Pakistan roaming option available"],
    color: "from-violet-500 to-purple-400",
  },
  {
    icon: "🏦",
    title: "Bank Account Processing",
    desc: "Opening a bank account abroad is complex. We guide you through the entire process with our bank contacts in each country.",
    features: ["Account opened before or after arrival", "Digital banks (Wise, Revolut) setup", "Student & international accounts", "IBAN & routing number arranged"],
    color: "from-amber-500 to-yellow-400",
  },
  {
    icon: "🔒",
    title: "Police Verification",
    desc: "Required for many visa applications and migration pathways. We manage the complete process including form submission and tracking.",
    features: ["Pakistan police character certificate", "NADRA attestation support", "Embassy-standard formatting", "Express processing available"],
    color: "from-red-500 to-rose-400",
  },
  {
    icon: "📜",
    title: "Document Attestation",
    desc: "Complete document attestation chain — Board, IBCC, HEC, MOFA, and Apostille — handled by our dedicated attestation team.",
    features: ["Board / Matric / Intermediate", "IBCC equivalency certificates", "HEC degree attestation", "MOFA attestation & Apostille"],
    color: "from-teal to-teal-light",
  },
  {
    icon: "🏠",
    title: "Accommodation Contract Clearance",
    desc: "We review your accommodation contract before you sign — checking legal terms, deposit conditions, and tenant rights in your destination country.",
    features: ["Full contract legal review", "Deposit & exit clause check", "Tenant rights briefing", "Renegotiation support if needed"],
    color: "from-indigo-500 to-blue-400",
  },
];

// ─── TEAM MEMBERS ───
export const teamMembers = [
  {
    name: "Hammad Khalid",
    role: "Founder & CEO",
    bio: "Visionary leader with 7+ years in global education and migration consultancy. Personally guided 500+ clients to their international goals.",
    initials: "HK",
    photo: "/team-hammad-khalid.jpg",
    color: "from-teal to-teal-light",
    expertise: ["Study Abroad Strategy", "Skilled Migration", "Business Development"],
    linkedin: "#",
  },
  {
    name: "Muhammad Afnan",
    role: "Senior RM & Migration Specialist",
    bio: "Relationship management expert and senior migration specialist with deep knowledge of skilled worker pathways across Australia, Canada, UK, and Germany.",
    initials: "MA",
    photo: "/team-muhammad-afnan.jpg",
    color: "from-navy to-blue-600",
    expertise: ["Skilled Migration", "Client Relations", "PR Pathways"],
    linkedin: "#",
  },
  {
    name: "Hasnaat Khalid",
    role: "Senior Manager Business Development",
    bio: "Drives Travizon's growth strategy and university partnership network. Expert in building institutional relationships across 35+ study destinations.",
    initials: "HK",
    photo: "/team-hasnaat-khalid.jpg",
    color: "from-indigo-500 to-blue-500",
    expertise: ["Business Development", "University Partnerships", "Strategy"],
    linkedin: "#",
  },
  {
    name: "Saleha Shahbaz",
    role: "Senior Admission Officer",
    bio: "Specialist in university admissions across UK, Canada, Europe and Australia. Has secured offers for 300+ students at top-ranked institutions.",
    initials: "SS",
    photo: "/team-saleha-shahbaz.jpg",
    color: "from-purple-500 to-violet-400",
    expertise: ["University Admissions", "SOP Writing", "Scholarship Guidance"],
    linkedin: "#",
  },
  {
    name: "Momna Akram",
    role: "Senior Graphic Designer",
    bio: "The creative force behind Travizon's brand identity. Brings clarity and professionalism to every client-facing document, presentation, and campaign.",
    initials: "MA",
    photo: "/team-momna-akram.jpg",
    color: "from-emerald-500 to-teal",
    expertise: ["Brand Design", "Client Documents", "Marketing Creatives"],
    linkedin: "#",
  },
  {
    name: "Imran Hameed",
    role: "Student Consular",
    bio: "Expert in student visa consultations and university guidance. Helps students navigate the admissions and visa process with clarity and confidence.",
    initials: "IH",
    photo: "/team-imran-hameed.jpg",
    color: "from-rose-500 to-pink-400",
    expertise: ["Student Visas", "University Guidance", "Visa Consultation"],
    linkedin: "#",
  },
];
